import {
  belgeCipi,
  HAREKET_TURU_METNI,
  KALDIRMA_NEDENI_METNI,
  KUTUK_KULLANIM_METNI,
  PAKET_BITTI_EKI,
  paketSecenekMetni,
  type BelgeCipiGirdisi,
  type HareketTuru,
  type KaldirmaNedeni,
  type KullanimOzeti,
  type PaketSecenegi,
} from "@oasis/domain";
import { cevir } from "@/lib/dil";
import { tarih } from "@/lib/veri";

/**
 * D-045 … D-052: stok paketi metinlerinin ekrandaki biçimi (seçim listeleri, Registers → Stock, belge çipleri).
 * Metinler alan paketinde İngilizce; burada `cevir` ve en-GB / tr-TR tarih ile gösterilir.
 */

/** Seçenek metninde tanımın en çok uzunluğu (uzun tanımlar "…" ile kısalır). */
export const PAKET_TANIM_EN_COK = 60;

/** Seçenek metni: "PN — tanım · <iz> · PO <no> · <kalan> <birim> · opening stock | arrived <tarih> · PKG-####". */
export const paketEtiketi = (p: PaketSecenegi) =>
  paketSecenekMetni(p, { cevir: (m, ...a) => cevir(m, ...a), tarih: (d) => tarih(d), tanimEnCok: PAKET_TANIM_EN_COK });

/** Kaldırılmış kullanımın nedeni ("selection changed" …); bilinmeyen değer olduğu gibi. */
export const kaldirmaNedeniMetni = (n: string | null) =>
  n === null ? "" : n in KALDIRMA_NEDENI_METNI ? cevir(KALDIRMA_NEDENI_METNI[n as KaldirmaNedeni]) : n;

/** Miktar geçmişinin tür adı ("opening stock", "arrival" …); bilinmeyen değer olduğu gibi. */
export const hareketTuruMetni = (t: string) => (t in HAREKET_TURU_METNI ? cevir(HAREKET_TURU_METNI[t as HareketTuru]) : t);

/** Kütük kullanım özeti: "used in 2 fit-ups · used in 1 pass record". */
export const kullanimMetni = (o: KullanimOzeti) =>
  o.parcalar
    .map((p) => {
      const [tekil, cogul] = KUTUK_KULLANIM_METNI[p.tur];
      return p.n === 1 ? cevir(tekil) : cevir(cogul, p.n);
    })
    .join(" · ");

/**
 * D-052: fit-up / weld map yeni malzemesinin "—" sonrası eki: paket → etiket (alan paketinin PAKET_BITTI_EKI eki ayrılıp
 * "(package finished)" çevrilir; PN, PO ve PKG no. çevrilmez); elle → sabit metin; eski biçim → etiket varsa o.
 */
export function malzemeEki(m: { sec: string; etiket?: string }): string | null {
  if (m.sec === "elle") return cevir("entered manually · not linked to a stock package");
  if (!m.etiket) return null;
  return m.etiket.endsWith(PAKET_BITTI_EKI) ? `${m.etiket.slice(0, -PAKET_BITTI_EKI.length)} ${cevir("(package finished)")}` : m.etiket;
}

/**
 * Belge çipi ("3.1 · p. 41–43", "PO 2025-0417" …); kısa tür çevrilir, tarih yerel biçimde.
 * D-064: yöntemi yazılı NDT sertifikasında "MT · Level 2 · MT-L2-0418 · p. 1" (yöntem çevrilmez, "Level 2" çevrilir); yöntemi boş eski satırda "NDT certificate · …".
 */
export const belgeCipiMetni = (b: BelgeCipiGirdisi) => belgeCipi(b, { cevir: (m) => cevir(m), tarih: (d) => tarih(d) });

export type { PaketSecenegi };
